// removed by extract-text-webpack-plugin
module.exports = {"container":"_1GANG","search":"_3ldLX","reply":"_2-Aa6","likeButton":"_2cnho","likeCount":"_1JeKO"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-footer/comment-footer.scss
// module id = 1120
// module chunks = 0 3 5